import * as React from 'react';

import { FormItem } from './FormItem';
import { VFFieldProps } from '../types';
import { ApiMultiSelectSearch } from '../../multiselect/ApiMultiSelectSearch';
import {
  defaultMultiSelectGetLabel,
  defaultMultiSelectRenderItem,
} from '../../multiselect/MultiSelectSearch';
import Field from '../Field';
import { FieldRenderProps } from 'react-final-form';
import { Text } from '../../typography/Text';
import { FilterInputButton } from '../../button/FilterInputButton';
import { Classes } from '../../index';
import { isMobile } from '../../common/utils';
import classNames from 'classnames';
import { DATA_FORM_INPUT } from '../../common/data';

export type ApiMultiSelectProps = Omit<
  Omit<
    VFFieldProps<React.ComponentProps<typeof ApiMultiSelectSearch>>,
    'value'
  >,
  'inlineValidation'
>;
export const ApiMultiSelect = React.forwardRef<
  HTMLInputElement,
  ApiMultiSelectProps
>(
  (
    {
      name,
      getLabel = defaultMultiSelectGetLabel,
      renderItem = defaultMultiSelectRenderItem,
      validate,
      className,
      inputClassName,
      contentClassName,
      label,
      required,
      disabled,
      searchItems,
      validateWarning,
      ...other
    },
    ref
  ) => {
    return (
      <FormItem
        name={name}
        className={className}
        label={label}
        required={required}
        disabled={disabled}
        validateWarning={validateWarning}
        contentClassName={contentClassName}
      >
        <Field name={name} validate={validate}>
          {({
            input: { value, onChange, onBlur, name, ...nother },
            meta,
          }: FieldRenderProps<any[]>) => {
            let titleArr: string[] = [];
            // let tooltipArr: any[] = [];
            value &&
              value.forEach((v) => {
                titleArr.push(getLabel(v));
                // tooltipArr.push(<ListItem>{renderItem(v)}</ListItem>);
              });

            let info: React.ReactNode = '-';
            if (!value || value.length === 0) {
              info = (
                <Text intent={'inactive'} italic>
                  Nevybráno
                </Text>
              );
            } else if (value.length === 1) {
              info = titleArr[0];
            } else {
              info = `${titleArr[0]} +${value.length - 1}`;
            }

            return (
              <FilterInputButton
                {...DATA_FORM_INPUT(name)}
                tooltip={
                  titleArr.length > 0 ? (
                    titleArr.join(', ')
                  ) : (
                    <Text intent={'inactive'} italic>
                      Nevybráno
                    </Text>
                  )
                }
                className={Classes.FORM_MULTI_SELECT}
                disabled={disabled || meta.submitting}
                popupProps={{
                  mode: 'edit',
                  closeOnInnerClick: false,
                  arrow: true,
                  focusContentOnOpen: true,
                  position: isMobile
                    ? ['bottom left', 'top left', 'bottom center', 'top center']
                    : undefined,
                }}
                menu={(closePopup) => (
                  <ApiMultiSelectSearch
                    closePopup={closePopup}
                    className={classNames(
                      inputClassName,
                      Classes.FORM_MULTI_LIST
                    )}
                    value={value}
                    // @ts-ignore
                    ref={ref}
                    {...nother}
                    {...other}
                    renderItem={renderItem}
                    onChange={(ids) => {
                      onChange({ target: { name, value: ids } });
                    }}
                    title={label}
                    searchItems={searchItems}
                  />
                )}
              >
                {info}
              </FilterInputButton>
            );
          }}
        </Field>
      </FormItem>
    );
  }
);
